/* global AddressFinder, Survey */

const initAddressFinder = () => {
    const widget = {
        name: "addressfinder",
        title: "Address Finder",
        iconName: "",
        widgetIsLoaded: function () {
            return true;
        },
        isFit: function (question) {
            return question.getType() === "addressfinder";
        },
        activatedByChanged: function () {
            Survey.JsonObject.metaData.addClass(
                "addressfinder",
                [],
                null,
                "text"
            );
        },
        isDefaultRender: false,
        htmlTemplate: `
<div>
  <input id='lookup' placeholder='Lookup New Zealand Address' class='form-control mt-2' />
  <input id='line1' placeholder='Address Line 1' class='form-control mt-2' />
  <input id='line2' placeholder='Address Line 2' class='form-control mt-2' />
  <input id='suburb' placeholder='Suburb' class='form-control mt-2' />
  <input id='city' placeholder='City' class='form-control mt-2' />
  <input id='postcode' placeholder='Postcode' class='form-control mt-2' />
  <input id='country' placeholder='Country' class='form-control mt-2' />
</div>`,
        afterRender: function (question, el) {
            const textInputs = el.getElementsByTagName("input");
            const textLookup = textInputs[0];
            textLookup.inputType = question.inputType;

            textLookup.onchange = function () {
                const textInputs = $("input");
                question.value = {
                    line1: textInputs[1].value,
                    line2: textInputs[2].value,
                    suburb: textInputs[3].value,
                    city: textInputs[4].value,
                    postcode: textInputs[5].value,
                    country: textInputs[6].value,
                };
            };
            const onReadOnlyChangedCallback = () => {
                if (question.isReadOnly) {
                    textLookup.setAttribute("disabled", "disabled");
                } else {
                    textLookup.removeAttribute("disabled");
                }
            };
            question.readOnlyChangedCallback = onReadOnlyChangedCallback;
            onReadOnlyChangedCallback();

            const addressWidget = new AddressFinder.Widget(
                textLookup,
                "496BET7XDRMA38YNUWGL",
                "NZ"
            );
            addressWidget.on("result:select", (value, item) => {
                let line1, line2, suburb;

                if (item.box_type) {
                    line1 =
                        item.box_type && item.number
                            ? `${item.box_type} ${item.number}`
                            : item.a;
                } else if (item.unit_identifier) {
                    line1 = `${item.unit_type} ${item.unit_identifier}`;
                    line2 = `${item.number + (item.alpha || "")} ${
                        item.street
                    }`;
                    suburb = item.suburb || "";
                } else {
                    line1 = `${item.number + (item.alpha || "")} ${
                        item.street
                    }`;
                    suburb = item.suburb || "";
                }

                const city = item.mailtown || item.city;
                const postcode = item.postcode;
                const country = "New Zealand";

                textInputs[1].value = line1 || "";
                textInputs[2].value = line2 || "";
                textInputs[3].value = suburb || "";
                textInputs[4].value = city || "";
                textInputs[5].value = postcode || "";
                textInputs[6].value = country || "";
                textLookup.onchange();
            });
        },
        willUnmount: function () {
            return null;
        },
    };

    // Register our widget in singleton custom widget collection
    Survey.CustomWidgetCollection.Instance.addCustomWidget(
        widget,
        "customtype"
    );

    window.widget = widget;
};

window.initAddressFinder = initAddressFinder;

function downloadAddressFinder() {
    const script = document.createElement("script");
    script.src = "https://api.addressfinder.io/assets/v3/widget.js";
    script.async = true;
    script.onload = initAddressFinder;
    document.body.appendChild(script);
}

document.addEventListener("DOMContentLoaded", downloadAddressFinder);
